module.exports = __webpack_public_path__ + "img/streak20.a8a84be8.png";